
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/reading-list",
      function () {
        return require("private-next-pages/learn/reading-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/reading-list"])
      });
    }
  